import { render } from "./Pros.vue?vue&type=template&id=488a2ea6&scoped=true"
import script from "./Pros.vue?vue&type=script&lang=js"
export * from "./Pros.vue?vue&type=script&lang=js"

import "./Pros.vue?vue&type=style&index=0&id=488a2ea6&scoped=true&lang=css"

import exportComponent from "/Users/andreaskura/repos/cio-online-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-488a2ea6"]])

export default __exports__